import { createSlice } from "@reduxjs/toolkit";

const initialReturnRequestsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  returnRequestForEdit: null,
  returnRequestItems: null,
  returnableOrderInfo: null,
  updated: false,
  error: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const returnRequestsSlice = createSlice({
  name: "returnRequests",
  initialState: initialReturnRequestsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    returnRequestsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    returnRequestFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.returnRequestForEdit = action.payload.returnRequest;
    },
    returnRequestItemsFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.returnRequestItems = action.payload.items;
    },
    returnableOrderInfoFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.returnableOrderInfo = action.payload.info;
    },
    returnableOrderInfoCleared: (state) => {
      state.returnableOrderInfo = null;
      state.error = null;
    },
    returnRequestUpdated: (state) => {
      state.actionsLoading = false;
      state.updated = !state.updated;
      state.error = null;
    }
  }
});
